import { useState, MouseEvent } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Logout from "@mui/icons-material/Logout";

const MenuLog = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const { name = "" } = accounts[0] ?? "";

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const signOutClickHandler = (instance: any, accounts: any) => {
    const homeAccountId = accounts[0].homeAccountId;
    const logoutRequest = {
      account: instance.getAccountByHomeId(homeAccountId),
      postLogoutRedirectUri: "/",
    };
    instance.logoutRedirect(logoutRequest);
  };

  const signInClickHandler = (instance: any) => {
    instance.loginRedirect();
  };

  const SignOutButton = () => {
    return isAuthenticated ? (
      <MenuItem onClick={() => signOutClickHandler(instance, accounts)}>
        <ListItemIcon>
          <Logout fontSize='small' />
        </ListItemIcon>
        Finalizar sesión
      </MenuItem>
    ) : (
      <MenuItem onClick={() => signInClickHandler(instance)}>
        <ListItemIcon>
          <Logout fontSize='small' />
        </ListItemIcon>
        Iniciar sesión
      </MenuItem>
    );
  };

  return (
    <>
      <Tooltip title='Account settings'>
        <IconButton
          onClick={handleClick}
          size='small'
          sx={{ ml: 2 }}
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup='true'
          aria-expanded={open ? "true" : undefined}
        >
          <Avatar sx={{ width: 32, height: 32 }}>M</Avatar>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id='account-menu'
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {name && (
          <div>
            <MenuItem>
              <Avatar />
              {name}
            </MenuItem>
            <Divider />
          </div>
        )}

        <SignOutButton />
      </Menu>
    </>
  );
};

export default MenuLog;
